import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';
import { Congreso } from '../../models/congreso.model';

// Servicios
import { CongresosService, UserService, TrabajosService, TrabajosInvitadosService, CategoriaTrabajoService, MailService } from '../../services/services.index';
import { User } from '../../models/user.model';
import { URL_SERVICES } from '../../config/config';

import * as XLSX from 'xlsx';
import { getCountryByCode, getCiudad } from '../../config/methods';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

declare var $;

@Component({
  selector: 'app-inscriptos-congreso',
  templateUrl: './inscriptos-congreso.component.html',
  styles: []
})
export class InscriptosCongresoComponent implements OnInit {

  congreso: Congreso = new Congreso();
  inscriptos: User[];
  totalRegistros: number;
  desde: number = 0;
  siguienteDisable: boolean = false;
  anteriorDisable: boolean = true;
  paypalCode: string = '';

  hideModal: string = 'hide-modal';
  hideModal2: string = 'hide-modal';
  hideModalTrabajo: string = 'hide-modal';
  hideModalTrabajoInvitado: string = 'hide-modal';
  hideModalAprobarInscripto: string = 'hide-modal';

  inscripto: User;

  URL_SERVICES: string = URL_SERVICES;

  filtroAprobados: boolean = false;
  filtroPendientesPago: boolean = false;
  filtroPendientesAprobacion: boolean = false;
  filtroInvitados: boolean = false;
  filtroTrabajosPresentados: boolean = false;
  filtroTrabajosAprobados: boolean = false;
  filtroTrabajosRechazados: boolean = false;
  filtroTrabajosInvitados: boolean = false;
  rowsByPage: number = 50;

  trabajo: any;
  trabajoInvitado: any;
  arbolDeCategorias: any;

  loading: boolean = true;

  constructor( private activatedRoute: ActivatedRoute,
    public _congresosService: CongresosService,
    public _userService: UserService,
    public _trabajosService: TrabajosService,
    public _trabajosInvitadosService: TrabajosInvitadosService,
    public _categoriaTrabajoService: CategoriaTrabajoService,
    public _mailService: MailService ) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['id'];
      let filtro: any = params['filtro'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        this.loading = false;
        if (filtro === 'aprobados') {
          this.filtrarAprobados();
        } else if (filtro === 'trabajosPresentados') {
          this.filtrarTrabajosPresentados();
        } else if (filtro === 'trabajosAprobados') {
          this.filtrarTrabajosAprobados();
        } else {
          this.cargarInscriptos();
        }
      });
    });
    $(document).ready(function() {
      $('body').tooltip({ selector: '[data-toggle=tooltip]' });
  });
  }

  hideModalMethod() {
    this.hideModal2 = 'hide-modal';
  }

  showModal() {
    this.hideModal2 = '';
  }

  hideModalPagoMethod() {
    this.hideModal = 'hide-modal';
  }

  hideModalRevisionTrabajo() {
    this.hideModalTrabajo = 'hide-modal';
  }

  hideModalAprobarInscriptoMethod() {
    this.hideModalAprobarInscripto = 'hide-modal';
  }

  showModalAprobarInscripto(inscripto: User, i: number) {
    $('#borrarTooltip_' + i).tooltip('hide');
    this.hideModalAprobarInscripto = '';
    this.inscripto = inscripto;
    this.paypalCode = '';
  }

  showModalRevisionTrabajo() {
    this.hideModalTrabajo = '';
  }

  hideModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = 'hide-modal';
  }

  showModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = '';
  }

  showModalPago() {
    this.hideModal = '';
  }

  buscarInscripto(termino: string) {
    if (termino.length === 0) {
      this.cargarInscriptos();
      return;
    }

    this._userService.buscarInscriptos(termino, this.congreso._id).subscribe((resp: any) => {
      this.inscriptos = resp.usuarios;
      this.totalRegistros = resp.total;
    });
  }

  cargarInscriptos() {
    this.loading = true;
    this._userService.getUsuariosPorCongreso(this.desde, this.rowsByPage, this.congreso._id).subscribe((resp: any) => {
      this.quitarFiltros();
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  siguiente() {

    this.desde = this.desde + this.rowsByPage;
    console.log(this.desde);

    if (this.filtroAprobados) {
      this.filtrarAprobados();
    } else if (this.filtroPendientesPago) {
      this.filtrarPendientePago();
    } else if (this.filtroPendientesAprobacion) {
      this.filtrarPendienteAprobacion();
    } else if (this.filtroInvitados) {
      this.filtrarUsuariosInvitados();
    } else if (this.filtroTrabajosPresentados) {
      this.filtrarTrabajosPresentados();
    } else if (this.filtroTrabajosAprobados) {
      this.filtrarTrabajosAprobados();
    } else if (this.filtroTrabajosRechazados) {
      this.filtrarTrabajosRechazados();
    } else if (this.filtroTrabajosInvitados) {
      this.filtrarTrabajosInvitados();
    } else {
      this.cargarInscriptos();
    }

    if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
      this.siguienteDisable = true;
    }

    if ((this.desde - this.rowsByPage) < 0) {
      this.anteriorDisable = true;
    } else {
      this.anteriorDisable = false;
    }
  }

  anterior() {

    this.desde -= this.rowsByPage;

    if (this.filtroAprobados) {
      this.filtrarAprobados();
    } else if (this.filtroPendientesPago) {
      this.filtrarPendientePago();
    } else if (this.filtroPendientesAprobacion) {
      this.filtrarPendienteAprobacion();
    } else if (this.filtroInvitados) {
      this.filtrarUsuariosInvitados();
    } else if (this.filtroTrabajosPresentados) {
      this.filtrarTrabajosPresentados();
    } else if (this.filtroTrabajosAprobados) {
      this.filtrarTrabajosAprobados();
    } else if (this.filtroTrabajosRechazados) {
      this.filtrarTrabajosRechazados();
    } else if (this.filtroTrabajosInvitados) {
      this.filtrarTrabajosInvitados();
    } else {
      this.cargarInscriptos();
    }


    if ((this.desde - this.rowsByPage) < 0) {
      this.anteriorDisable = true;
    }
    if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
      this.siguienteDisable = true;
    } else {
      this.siguienteDisable = false;
    }

  }

  verInscripcion(inscripto: User, i: number) {
    $('#verTooltip_' + i).tooltip('hide');
    this.inscripto = inscripto;
    this.showModal();
  }

  revisarPago(inscripto: User, i: number) {
    $('#pagoTooltip_' + i).tooltip('hide');
    this.inscripto = inscripto;
    this.showModalPago();
  }

  aprobarPago(inscripto: User) {
    this._userService.aprobarPago(inscripto._id).subscribe(resp => {
      this._mailService.mailParaUsuario('pagoaprobado', this.congreso.titulo_es, inscripto.name, inscripto.apellido, inscripto.email, inscripto.lang, this.congreso.sociedadOrganizadora).subscribe(ok => {});
      this.hideModalPagoMethod();
      this.cargarInscriptos();
      swal('Pago Aprobado', 'El pago ah sido aprobado satisfactoriamente', 'success');
    });
  }

  quitarFiltros() {
    this.filtroAprobados = false;
    this.filtroPendientesAprobacion = false;
    this.filtroPendientesPago = false;
    this.filtroInvitados = false;
    this.filtroTrabajosPresentados = false;
    this.filtroTrabajosAprobados = false;
    this.filtroTrabajosRechazados = false;
    this.filtroTrabajosInvitados = false;
  }

  filtrarAprobados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosAprobados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroAprobados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarPendienteAprobacion(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosPendientesAprobacion(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroPendientesAprobacion = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarPendientePago(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosPendientesPago(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroPendientesPago = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarUsuariosInvitados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosInvitados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroInvitados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarTrabajosPresentados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosTrabajosPresentados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroTrabajosPresentados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarTrabajosInvitados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosTrabajosInvitadosPresentados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroTrabajosInvitados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarTrabajosAprobados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosTrabajosAprobados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroTrabajosAprobados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  filtrarTrabajosRechazados(boton ?: boolean) {
    this.loading = true;
    if (boton) {
      this.desde = 0;
    }
    this._userService.getUsuariosTrabajosRechazados(this.congreso._id, this.rowsByPage, this.desde).subscribe((resp: any) => {
      this.quitarFiltros();
      this.filtroTrabajosRechazados = true;
      this.inscriptos = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  revisarTrabajo(inscripto: User, i: any) {
    this.loading = true;
    $('#trabajoTooltip_' + i).tooltip('hide');
    this.inscripto = inscripto;
    this._trabajosService.getTrabajo(inscripto).subscribe((trabajo: any) => {
      this.trabajo = trabajo;
      this.loading = false;
      this._categoriaTrabajoService.getArbolCategorias(this.trabajo.categoriasTrabajo).subscribe((resp: any) => {
        this.arbolDeCategorias = resp.categoriasTrabajo.reverse();
      });
      this.showModalRevisionTrabajo();
    });
  }

  revisarTrabajoInvitado(inscripto: User, trabajo_id: any, i) {
    this.loading = true;
    $('#trabajoInvitadoTooltip_' + i).tooltip('hide');
    this.inscripto = inscripto;
    this._trabajosInvitadosService.getUnTrabajo(trabajo_id).subscribe(trabajo => {
      this.trabajo = trabajo;
      this.loading = false;
      this.showModalRevisionTrabajo();
    });
  }

  aprobarTrabajo(tituloTrabajo: string) {
    this._userService.aprobarTrabajo(this.inscripto._id).subscribe((resp: User) => {
      this._mailService.mailParaUsuario('trabajoaprobado', this.congreso.titulo_es, this.inscripto.name, this.inscripto.apellido, this.inscripto.email, this.inscripto.lang, this.congreso.sociedadOrganizadora, tituloTrabajo).subscribe(ok => {});
      this.hideModalRevisionTrabajo();
      this.cargarInscriptos();
      swal('Trabajo Aprobado', 'El trabajo ah sido aprobado satisfactoriamente', 'success');
    });
  }

  rechazarTrabajo(trabajo_id: any, tituloTrabajo: string) {
    this.hideModalRevisionTrabajo();
    swal({
      title: 'Rechazar Trabajo',
      text: '¿Desea rechazar el trabajo?',
      icon: 'info',
      buttons: ['No', 'Si']
    })
    .then((willDelete) => {
      if (willDelete) {
        this._userService.rechazarTrabajo(this.inscripto._id).subscribe((resp: User) => {
          this._mailService.mailParaUsuario('trabajorechazado', this.congreso.titulo_es, this.inscripto.name, this.inscripto.apellido, this.inscripto.email, this.inscripto.lang, this.congreso.sociedadOrganizadora, tituloTrabajo).subscribe(ok => {});
          this.hideModalRevisionTrabajo();
          this.cargarInscriptos();
          swal('Trabajo Rechazado', 'El trabajo ah sido rechazado satisfactoriamente', 'success');
        });
      }
    });
  }

  reiniciarTrabajo(trabajo_id: any, tituloTrabajo: string) {
    this.hideModalRevisionTrabajo();
    swal({
      title: 'Reiniciar Trabajo',
      text: '¿Desea reiniciar el trabajo? En este caso el usuario podrá enviar un trabajo nuevo.',
      icon: 'info',
      buttons: ['No', 'Si']
    })
    .then((willDelete) => {
      if (willDelete) {
        this._trabajosService.reiniciarTrabajo(this.trabajo._id).subscribe(resp => {
          this._mailService.mailParaUsuario('trabajoreinicio', this.congreso.titulo_es, this.inscripto.name, this.inscripto.apellido, this.inscripto.email, this.inscripto.lang, this.congreso.sociedadOrganizadora, tituloTrabajo).subscribe(ok => {});
          this.cargarInscriptos();
          swal('Trabajo Reiniciado', 'El trabajo ah sido reiniciado satisfactoriamente. El inscripto puede volver a enviarlo.', 'success');
        });
      }
    });

  }

  reiniciarTrabajoInvitado(trabajo_id: any) {
    this.hideModalRevisionTrabajo();
    swal({
      title: 'Reiniciar Trabajo',
      text: '¿Desea reiniciar el trabajo? En este caso el usuario podrá enviar un trabajo nuevo.',
      icon: 'info',
      buttons: ['No', 'Si']
    })
    .then((willDelete) => {
      if (willDelete) {
        this._trabajosInvitadosService.reiniciarTrabajo(trabajo_id).subscribe(resp => {
          this.cargarInscriptos();
          swal('Trabajo Reiniciado', 'El trabajo ah sido reiniciado satisfactoriamente. El inscripto puede volver a enviarlo.', 'success');
        });
      }
    });

  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1) + '.';
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    for (let lugar of lugaresTrabajo) {
      if (superindice === '') {
        superindice = superindice + lugar;
      } else {
        superindice = superindice + ',' + lugar;
      }
    }
    return superindice;
  }

  inscriptosFiltrados() {
    if ( this.filtroAprobados ||
        this.filtroPendientesPago ||
        this.filtroPendientesAprobacion ||
        this.filtroInvitados ||
        this.filtroTrabajosAprobados ||
        this.filtroTrabajosPresentados ||
        this.filtroTrabajosRechazados ||
        this.filtroTrabajosInvitados ) {
          return true;
        } else {
          return false;
        }
  }

  getEstadoTrabajo(estado: string) {
    if (estado !== 'pendiente') {
      return 'SI';
    } else {
      return 'NO';
    }
  }

  generateExcel() {
    this.loading = true;

    let listadoImprimir: any[] = [];

    let tituloListado: string;
    let inscriptosImprimir: any[];
    let nombreArchivo: string;

    if (this.filtroAprobados) {
      tituloListado = 'Inscriptos Aprobados';
      nombreArchivo = 'aprobados';
      this._userService.getUsuariosAprobados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }

          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroPendientesPago) {
      tituloListado = 'Inscriptos Pendientes de Pago';
      nombreArchivo = 'pendiente-pago';
      this._userService.getUsuariosPendientesPago(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroPendientesAprobacion) {
      tituloListado = 'Inscriptos Pendientes de Aprobación';
      nombreArchivo = 'pendiente-aprobacion';
      this._userService.getUsuariosPendientesAprobacion(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroInvitados) {
      tituloListado = 'Inscriptos Invitados';
      nombreArchivo = 'invitados';
      this._userService.getUsuariosInvitados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, , getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroTrabajosPresentados) {
      tituloListado = 'Inscriptos con Trabajos Presentados';
      nombreArchivo = 'trabajos-presentados';
      this._userService.getUsuariosTrabajosPresentados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, , getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroTrabajosAprobados) {
      tituloListado = 'Inscriptos con Trabajos Aprobados';
      nombreArchivo = 'trabajos-aprobados';
      this._userService.getUsuariosTrabajosAprobados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, , getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroTrabajosRechazados) {
      tituloListado = 'Inscriptos con Trabajos Rechazados';
      nombreArchivo = 'trabajos-rechazados';
      this._userService.getUsuariosTrabajosRechazados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, , getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else if (this.filtroTrabajosInvitados) {
      tituloListado = 'Insriptos con Trabajos como Invitados';
      nombreArchivo = 'trabajos-invitados';
      this._userService.getUsuariosTrabajosInvitadosPresentados(this.congreso._id, 0, 0).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, , getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    } else {
      tituloListado = 'Todos los inscriptos';
      nombreArchivo = 'todos';
      this._userService.getUsuariosPorCongreso(0, 0, this.congreso._id).subscribe((resp: any) => {
        inscriptosImprimir = resp.users;
        listadoImprimir.push([tituloListado]);

        listadoImprimir.push(['DNI', 'Nombre', 'Apellido', 'Email', 'Categoria Inscripción', 'Sociedad', 'Pais Residencia', 'Ciudad', 'Presentó Resumen']);

        for (let inscripto of inscriptosImprimir) {
          let arrInscripto: any[];
          if (inscripto.socio) {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, inscripto.sociedad, getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          } else {
            arrInscripto = [inscripto.dni, inscripto.name, inscripto.apellido, inscripto.email, inscripto.categoriaInscripcion.categoriaInscripcion.nombre_es, '', getCountryByCode(inscripto.paisResidencia), getCiudad(inscripto.ciudad), this.getEstadoTrabajo(inscripto.estadoTrabajo)];
          }
          listadoImprimir.push(arrInscripto);
        }

        this.excelMethods(listadoImprimir, nombreArchivo);
      });
    }

  }

  excelMethods(listadoImprimir: any, nombreArchivo: any) {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(listadoImprimir);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inscriptos');

    /* save to file */
    XLSX.writeFile(wb, 'listado-inscriptos-' + nombreArchivo + '.xlsx');
    this.loading = false;
  }

  borrarInscripto(inscripto: User, i: number) {
    $('#borrarTooltip_' + i).tooltip('hide');
    swal({
      title: 'Borrar Inscripto',
      text: '¿Desea borrar el inscripto junto con los pagos y trabajos enviados?',
      icon: 'error',
      buttons: ['No', 'Si']
    })
    .then((willDelete) => {
      if (willDelete) {
        this.loading = true;
        this._userService.deleteInscripto(inscripto).subscribe(resp => {
          this.loading = false;
          swal('Usuario Borrado', 'El usuario fue borrado satisfactoriamente', 'success');
          this.cargarInscriptos();
        });
      }
    });
  }

  esExtranjeroPagoPendiente(inscripto: User) {
    if (inscripto.paisResidencia !== 'AR' && inscripto.pago === false) {
      return true;
    } else {
      return false;
    }
  }

  aprobarInscriptoExtranjero(inscripto: User) {
    console.log(inscripto);
    this.hideModalAprobarInscriptoMethod();
    swal({
      title: 'Aprobar Inscripto',
      text: '¿Desea aprobar inscripto?',
      icon: 'info',
      buttons: ['No', 'Si']
    })
    .then((willAprove) => {
      if (willAprove) {
        console.log('Aprobar Inscripto');
        console.log(inscripto);
        console.log(this.calcularTotalAprobacionPaypal(inscripto));
        let payment: any = {
          manual: true,
          idPaypal: this.paypalCode
        };
        console.log(payment);
        let total: number = this.calcularTotalAprobacionPaypal(inscripto);
        this._userService.registrarPagoPaypal(inscripto, payment, inscripto.categoriaInscripcion, inscripto.actividades, total).subscribe(resp => {
          this.cargarInscriptos();
          swal('Inscripto Aprobado', 'El inscripto fue aprobado correctamente', 'success');
        });
      }
    });
  }

  calcularTotalAprobacionPaypal(inscripto: User) {
    let total: number = 0;
    for (let actividad of inscripto.actividades) {
      total = total + actividad.precio_usd;
    }
    return total + inscripto.categoriaInscripcion.precio_usd;
  }

  cambiarPaginacion() {
    console.log(this.rowsByPage);
    this.desde = 0;
    this.cargarInscriptos();
    if ((this.desde + this.rowsByPage) >= this.totalRegistros) {
      this.siguienteDisable = true;
    }

    if ((this.desde - this.rowsByPage) < 0) {
      this.anteriorDisable = true;
    } else {
      this.anteriorDisable = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/inscriptos-congreso/inscriptos-congreso.component.ts